<template>
  <div class="topbar" :class="{ active: active }">
    <div class="topbar__fill" :style="{ width: pct + '%' }"></div>
  </div>
</template>

<script>
// Simple NProgress-style top bar controlled by a global event bus.
// Call window.$km.loader.start() / .done() to drive it.
export default {
  name: 'TopProgress',
  data(){ return { active: false, pct: 0, pending: 0, tick: null }; },
  mounted(){
    if(!window.$km) window.$km = {};
    window.$km.loader = {
      start: () => this.start(),
      done:  () => this.done()
    };
  },
  beforeDestroy(){
    if(this.tick) clearInterval(this.tick);
    if(window.$km && window.$km.loader) delete window.$km.loader;
  },
  methods: {
    start(){
      this.pending++;
      if(this.pending > 1) return;
      this.active = true;
      this.pct = 8;
      clearInterval(this.tick);
      this.tick = setInterval(() => {
        // asymptotic — never reaches 100 until done()
        const delta = Math.max(0.5, (90 - this.pct) * 0.06);
        this.pct = Math.min(this.pct + delta, 92);
      }, 180);
    },
    done(){
      this.pending = Math.max(0, this.pending - 1);
      if(this.pending > 0) return;
      clearInterval(this.tick);
      this.pct = 100;
      setTimeout(() => { this.active = false; this.pct = 0; }, 320);
    }
  }
}
</script>

<style scoped>
.topbar {
  position: fixed; top: 0; left: 0; right: 0;
  height: 3px; z-index: 10000; pointer-events: none;
  opacity: 0; transition: opacity .25s ease;
}
.topbar.active { opacity: 1; }
.topbar__fill {
  height: 100%;
  background: linear-gradient(90deg, #ff4d8d 0%, #a020f0 50%, #ff4d8d 100%);
  background-size: 200% 100%;
  box-shadow: 0 0 10px rgba(255,77,141,.7), 0 0 20px rgba(160,32,240,.5);
  transition: width .25s ease-out;
  animation: gradShift 2s linear infinite;
}
@keyframes gradShift {
  0% { background-position: 0% 0; }
  100% { background-position: 200% 0; }
}
</style>
